// extracted by mini-css-extract-plugin
export default {"wrapper":"MiddleFacet_wrapper__CMz4O"};